module.exports = __webpack_public_path__ + "static/media/family-small.2e73355e.jpeg";